<ngx-select
    [noAutoComplete]="false"
    [allowClear]="false"
    (select)="onChange($event)"
    [items]="supplierFilterOptions"
></ngx-select>
